import { defineMessages } from 'react-intl';

const messages = defineMessages({
  WithEmployeeTags: 'With employee tags',
  Name: 'Name',
  AbsenceCounters: 'Absence counters',
  Actions: 'Actions',
  AllMainTasks: 'All main tasks',
  Employee: 'Employee',
  ResetFilters: 'Reset filters',
  OwnCompany: 'Own company',
  FilterResource: 'Filter resource',
  OpenRegistrationOverview: 'Open registration overview',
  Delete: 'Delete',
  AbsenceBalance: 'Balance',
  AbsenceStartValue: 'Start value',
  AbsenceCorrections: 'Absence corrections',
  OpenDetails: 'Open details',
  Date: 'Date',
  Type: 'Type',
  BalanceBefore: 'Balance before',
  Mutation: 'Mutation',
  BalanceAfter: 'Balance after',
  Remark: 'Remark',
  AddCorrection: 'Add correction',
  Add: 'Add',
  Close: 'Close',
  Save: 'Save',
  RemoveCorrection: 'Remove correction',
  DeleteCorrectionMsg: 'Are you sure you want to delete this absence correction?',
  GlobalActions: 'Global actions',
  InitializeCounter: 'Initialize counter',
  BackgroundJobQueued: 'A background job has started. Click here to monitor the progress.',
  Resource: 'Resource',
  Year: 'Year',
  Action: 'Action',
  SetStartValue: 'Set start value',
  CopyFromPreviousYear: 'Copy from previous year',
  Hours: 'Hours',
  HoursAbbreviated: 'h',
  MinutesAbbreviated: 'm',
  Days: 'Days',
  DaysAbbreviated: 'd',
  OverrideIfCounterAlreadyExists: 'Override if counter already exists',
  RemoveExistingCorrections: 'Remove existing corrections',
  CounterBalanceStartValue:
    '{balanceDays} days of {startValueDays} remaining ({balanceHours}/{startValueHours} hours)',
  OpenEmployeeDetail: 'Open employee detail',
  HoursInDay: 'Hours in day',
  ShowAbsencesInDays: 'Show absences in days',
  ShowOnlyOpenAbsences: 'Show only employees with open absences',
  EmployeeType: 'Employee type',
  AssignmentAnalysisEmployeeRelationMatrix: 'Employee-Relation matrix',
  AssignmentAnalysisEmployeeTaskMatrix: 'Employee-Task matrix',
  EmployeeCapacityReport: 'Employee capacity report',
  EmployeeRole: 'Employee role',
  EmployeeFullWeeklyCapacity: 'Total weekly capacity',
  EmployeeWeeklyCapacity: 'Weekly capacity',
  EmployeeRemainingCapacity: 'Remaining capacity',
  EmployeeTotalCapacity: 'Total capacity',
  EmployeeAvailableCapacity: 'Available capacity',
  EmployeeRemainingCapacityTooltip:
    'Total productive working hours from today until the end of the selected period.',
  EmployeeTotalCapacityTooltip:
    'Total productive working hours for the entire selected period.',
  EmployeeAvailableCapacityTooltip:
    'Remaining capacity minus planned task hours and planned absences.',
  Totals: 'Totals',
  AllEmployeeRoles: 'All employee profiles',
  ExportToExcel: 'Export to Excel',
  ExportToExcelStarted: 'Export to Excel started',
  ColumnConfig: 'Configure columns',
  SelectColumns: 'Select columns',
  NoEmployeesFound: 'No employees found',
  ShowInRelationsOverview: 'Show in relations overview',
  ShowInTasksOverview: 'Show in tasks overview',
  DeadlineFrom: 'Deadline from',
  DeadlineUntil: 'Deadline until',
  Unassigned: 'Unassigned',
  Default: 'Default',
  CapacityDisplayMode: 'Display mode',
  CapacityDisplayModeDuration: 'Duration',
  CapacityDisplayModeTaskCount: 'Task count',
  CapacityDisplayModeRelationCount: 'Relation count',
  CapacityGroupByMonth: 'Group by month',
  CapacityMaxDateWarning: 'The dates cannot be later than the end of next year.',
  CapacityGroupHeader: 'Capacity',
  CapacityMonthOverview: 'Month overview',
  CapacityTasks: 'Tasks',
  CapacityTasksCount: 'Tasks (amount)',
  CapacityTasksRelations: 'Tasks (relations)',
  WithoutTemplate: 'Without Template',
});

export default messages;
